<template>
  <div
    :class="this.$store.state.cart.cartFlag ? 'cart-drawer show' : 'cart-drawer'"
    id="cart-drawer"
  >
    <div class="cart-drawer-inner text-large light">
      <Hamburger v-on:show-modal="hideSection" classes="hamburger-container close" />

      <div class="container">
        <h2>My bag</h2>
      </div>

      <div v-if="this.$store.state.cart.childDataLoaded" class="cart-container container">
        <div v-if="this.$store.state.cart.cart.length > 0" class="cart-inner-container">
          <div
            v-for="(cartItem, index) in this.$store.state.cart.cart"
            :key="index"
            class="cart-item-outer"
          >
            <div class="cart-item">
              <div class="product-image text-center">
                <a href="#" class="product-image-link">
                  <img :src="cartItem.image" width="50px" alt="cart product thumbnail" />
                </a>
              </div>

              <div class="product-title">
                <a :href="cartItem.url" class="medium-bold">{{ cartItem.title }}</a>

                <br />

                <span>{{ cartItem.variantOptions[0] }} / {{ cartItem.variantOptions[1] }}</span>

                <span
                  class="properties"
                  v-if="typeof cartItem.properties !== undefined && cartItem.properties !== null"
                >
                  <br />
                  <span
                    class="light text-xsmall"
                    v-if="
                      typeof cartItem.properties['pre-order-info'] !== undefined &&
                        cartItem.properties['pre-order-info'] !== null
                    "
                    >{{ cartItem.properties['pre-order-info'] }}
                  </span>
                </span>

                <div class="qty-selector">
                  <button
                    type="button"
                    class="qty__adjust"
                    :id="'qty-minus-' + cartItem.id"
                    aria-label="quantity subtract button"
                    @click="minus(cartItem.id, index)"
                  >
                    <span class="plus minus">&nbsp;</span>
                  </button>

                  <input
                    type="text"
                    :key="cartItem.id"
                    :value="cartItem.qty"
                    name="updates[]"
                    :id="'cdupdates_' + cartItem.id"
                    class="qty"
                    :data-id="cartItem.id"
                    min="0"
                    aria-label="shopping cart item quantity input"
                    @change="qtyUpdate($event.target.value, index, cartItem.id, cartItem.qty)"
                  />

                  <button
                    type="button"
                    class="qty__adjust"
                    :id="'qty-plus-' + cartItem.id"
                    aria-label="quantity add button"
                    @click="plus(cartItem.id, index)"
                  >
                    <span class="plus">&nbsp;</span>
                  </button>
                </div>
              </div>

              <div class="product-total text-large">
                {{ titleOptimiser(cartItem.linePrice / 100) }}
              </div>
            </div>

            <div class="flash-message text-xsmall normal-bold" :id="'outOfStock-' + cartItem.id">
              Hurry! This is the last item available
            </div>

            <div class="flash-message text-xsmall normal-bold" :id="'customMessage-' + cartItem.id">
              Please enter a smaller quantity
            </div>
          </div>
        </div>

        <div v-else class="empty-bag information">
          Your bag is empty
          <!-- 					<p>Click <a :href="emptyCartLink"><span style="text-decoration: underline;">here</span></a> to start shopping</p> -->
        </div>
      </div>

      <div v-else class="cart-container container loading">
        <div class="top-container">
          <div class="top-container-inner">
            <img src="../../assets/loader.gif" alt="spinner icon" />

            <div class="information">Loading your cart</div>
          </div>
        </div>
      </div>

      <div class="checkout-block container">
        <div class="subtotal edged-centered-space-evenly-flexbox h4 dark">
          <span>SubTotal</span>
          <span>{{ titleOptimiser(this.$store.state.cart.subTotal / 100) }}</span>
        </div>

        <div class="shipping-disclaimer">Shipping calculated at checkout</div>
        <div :class="currencyMessageClasses">
          The final price will be displayed in {{ baseCurrency }} at checkout
        </div>

        <a href="/checkout" class="btn btn--large cart-checkout">Checkout</a>

        <a href="/cart" class="btn cart-checkout">My Bag</a>
      </div>
    </div>
  </div>
</template>

<script>
import Hamburger from '../atoms/Hamburger.vue'
import shopifyConnector from '../../helpers/shopify-api.js'

export default {
  components: {
    Hamburger,
  },
  data: function() {
    return {
      baseCurrency: window.argent.baseCurrency,
      currentCurrency: window.argent.currency,
      showCurrencyMessage: false,
    }
  },
  components: {
    Hamburger,
  },
  props: {
    emptyCartLink: { type: String, default: '/collections/dresses' },
  },
  mounted: function() {
    if (this.baseCurrency !== this.currentCurrency) {
      this.showCurrencyMessage = true
    }
  },
  computed: {
    currencyMessageClasses: function() {
      const classes = ['currency-message']

      if (this.showCurrencyMessage) classes.push('show')
      return classes
    },
  },
  methods: {
    qtyUpdate: function(val, index, id, currentQty = 0) {
      /* We reset all the flash messages */
      let flashMessages = document.getElementsByClassName('flash-message')

      /* We decide whetherto subtract from or add to current cart count */
      let alterQty = val - currentQty

      for (let i = 0; i < flashMessages.length; i++) {
        flashMessages[i].style.height = 0
      }

      let payload = { quantity: val, index: index, id: id, alterQty: alterQty }

      this.$store.dispatch('changeCart', payload)
    },
    hideSection: function() {
      this.$store.commit('showCart')
      return this.$store.state.cartFlag
    },
    minus: function(id, index) {
      let quantityField = document.getElementById('cdupdates_' + id)
      quantityField.value--

      this.qtyUpdate(quantityField.value, index, id)
    },
    plus: function(id, index) {
      let quantityField = document.getElementById('cdupdates_' + id)
      quantityField.value++

      this.qtyUpdate(quantityField.value, index, id)
    },
    titleOptimiser: value => window.argent.convertFormatted(value),
  },
}
</script>
